/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as yup from "yup";

export const EnvironmentSchema = yup.object().shape({
  type: yup.string().required(),
  name: yup.string().required(),
  ownerId: yup.string(),
  description: yup.string(),
});
